import { render, staticRenderFns } from "./CommonError.vue?vue&type=template&id=380858d6&scoped=true"
import script from "./CommonError.vue?vue&type=script&lang=ts"
export * from "./CommonError.vue?vue&type=script&lang=ts"
import style0 from "./CommonError.vue?vue&type=style&index=0&id=380858d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380858d6",
  null
  
)

export default component.exports